import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { BarChart3, DollarSign, ShieldAlert } from 'lucide-react'
import TradingReport from '../TradingReport'
import DividendTracker from '../DividendTracker'
import RiskAnalysis from '../RiskAnalysis'
import { pageContainerVariants, pageItemVariants } from '../../constants/motionVariants'

type Tab = 'trading' | 'dividends' | 'risk'

const TABS = [
  { id: 'trading' as Tab, label: 'ประวัติซื้อขาย', icon: <BarChart3 className="w-4 h-4" />, active: 'border-indigo-500 text-indigo-600 dark:text-indigo-400' },
  { id: 'dividends' as Tab, label: 'เงินปันผล', icon: <DollarSign className="w-4 h-4" />, active: 'border-emerald-500 text-gain' },
  { id: 'risk' as Tab, label: 'Risk Analysis', icon: <ShieldAlert className="w-4 h-4" />, active: 'border-violet-500 text-violet-600 dark:text-violet-400' },
]

const TradingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('trading')

  return (
    <motion.div variants={pageContainerVariants} initial="hidden" animate="visible" className="space-y-4">
      <motion.div
        variants={pageItemVariants}
        className="card  overflow-hidden"
      >
        {/* Tab bar */}
        <div className="flex border-b border-gray-100 dark:border-gray-700/50">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                activeTab === tab.id
                  ? tab.active
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content — all tabs stay mounted */}
        <div style={{ display: activeTab === 'trading' ? 'block' : 'none' }}>
          <TradingReport />
        </div>
        <div style={{ display: activeTab === 'dividends' ? 'block' : 'none' }}>
          <DividendTracker />
        </div>
        <div style={{ display: activeTab === 'risk' ? 'block' : 'none' }}>
          <RiskAnalysis />
        </div>
      </motion.div>
    </motion.div>
  )
}

export default TradingPage
